/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface Office { 
    id?: string;
    name?: string;
    full_address?: string;
    radius?: number;
    created_at?: Date;
    created_by?: string;
    modified_at?: Date;
    modified_by?: string;
    parent_id?: string;
    is_office?: boolean;
    longitude?: number;
    latitude?: number;
    office_type_id?: string;
    code?: string;
}